import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { put } from "services/httpService";
import { broadcastStateUpdated } from "state/messageState";
import { testId } from "tests/testIdStrings";
import { Broadcast } from "types/broadcast";
import { API_URL_COM } from "utils/constants";
import { DialogMessage } from "utils/helpers/DialogMessage";
import { wait } from "utils/waitPromise";

export const SystemMessage = ({ message, onClose }: { message: Broadcast; onClose: () => void }) => {
  const [open, setOpen] = useState(true);
  const updateBroadcastState = useSetRecoilState(broadcastStateUpdated);

  const handleClose = () => {
    markAsRead();
    setOpen(false);
    onClose();
  };

  const markAsRead = async () => {
    console.log("Marking notification as read");
    try {
      await put(`${API_URL_COM}broadcasts/${message.id}/mark-as-read`, {});
      wait(650).then(() => {
        updateBroadcastState((n: number) => n + 1);
      });
    } catch (error) {
      console.error("Failed to mark conversation as read:", error);
    }
  };

  return (
    <DialogMessage
      title="common.title.system-message"
      open={open}
      close={handleClose}
      primaryButtonText="common.close"
      noCancelButton
      dataTestIdString={testId.common.close}
    >
      <Stack spacing={2}>
        <Typography variant="h6" fontWeight={700}>
          {message.subject ? message.subject : "Systemmeddelande"}
        </Typography>

        <Typography variant="body1">{message.content ? message.content : "Inget meddelande tillgängligt"}</Typography>
      </Stack>
    </DialogMessage>
  );
};
